import Modal from "./Modal";
import React, { useEffect, useRef } from "react";
import { ModalSize } from "../enums/ModalSize";
import { PdsModal } from "@principal/design-system-react";
import { useFormikContext } from "formik";
import { FormValues } from "../common/FormValues";
import { PfmlEmployerFormValues } from "../pfml/PfmlEmployerFormValues";
import Button from "../button/Button";
import CenteredFullWidthDiv from "./CenteredFullWidthDiv";
import Checkbox from "../input/Checkbox";

export type EmployerReimbursementModalProps = {
    onClose?: (e: Event) => void,
    inModal?: boolean
}

const EmployerReimbursementModal = (props: EmployerReimbursementModalProps) => {
    const { values } = useFormikContext<FormValues>();
    const consent = (values as PfmlEmployerFormValues).employerReimbursementConsent;
    const modalRef = useRef<typeof PdsModal & { openModal: Function, closeModal: Function }>(null);

    useEffect(() => {
        if(props.inModal && modalRef.current) {
            modalRef.current.openModal();
        }
    }, [props.inModal])

    const handleContinue = () => {
        modalRef.current?.closeModal(new CustomEvent('close'));
    }

    return <Modal id="employer-reimbursement-consent-validation"
                  headerText="Employer reimbursement policyholder responsibilities"
                  ref={modalRef}
                  modalContent={
                      <div>
                          <label className='block-label'>
                              Policyholder as an agent of Principal® understands and
                              acknowledges that it is the
                              responsibility of Policyholder to withhold and remit
                              accurate taxes from compensation paid to the employee
                              representing the PFML benefit.
                          </label>
                          <label className='block-label'>
                              Policyholder as an agent of Principal understands and
                              acknowledges that it is the
                              responsibility of Policyholder to report compensation
                              representing PFML benefits on Form W-2 and/or Form
                              1099-MISC.
                          </label>
                          <label className='block-label'>
                              Policyholder agrees to indemnify, hold harmless, and
                              release Principal from any liability
                              and damages associated with the actions herein
                              described perform by Policyholder as an agent of
                              Principal.
                          </label>
                          <label className='block-label'>
                              Principal agrees to reimburse the Policyholder for
                              benefits paid in advance. Policyholder
                              will only be reimbursed for days paid that
                              Principal has deemed the employee is eligible for
                              benefits and at the amount the
                              Principal has calculated is due.
                          </label>
                          <label className='block-label'>
                              The PFML reimbursement will be issued via check
                              separately by employee.
                          </label>
                          <label className='block-label'>
                              This agreement may be terminated by Principal anytime.
                          </label>
                          <CenteredFullWidthDiv divContent={
                              <Checkbox id="employer-reimbursement-consent" label="I agree"/>
                          }/>
                      </div>}
                  modalFooter={<>
                      {consent && <Button buttonContent="Continue" onClick={handleContinue}/>}
                  </>}
                  onClose={props.onClose}
                  modalSize={ModalSize.LARGE}
                  openOnLoad={false}
                  closeable={true}/>;
}

export default EmployerReimbursementModal;
